import React from 'react';
import Image from 'next/legacy/image';
import classnames from 'classnames';

import arrowDown from '../../public/images/arrow-down.svg';

interface SectionHeaderProps {
  title: string;
  altText?: string;
  containerClassName?: string;
  titleClassName?: string;
  showArrow?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  altText,
  containerClassName = 'container',
  titleClassName = 'text-23-29-0.77 uppercase whitespace-pre-line w-max lg:text-30-36-1 md:mx-4 font-sohneBreitBuch',
  showArrow = true,
}) => {
  return (
    <section className={containerClassName}>
      <div className="flex">
        <div className="items-center justify-center hidden w-10 mx-2 md:flex lg:w-16">
          <div className="w-10 lg:w-16 h-0.5 bg-black" />
        </div>
        <div className={classnames('justify-center', titleClassName)}>
          <button className="flex items-start text-left uppercase">
            {showArrow && (
              <div className="block w-8 mr-1 md:hidden">
                <Image src={arrowDown} alt={altText || title} />
              </div>
            )}
            <h2 className="whitespace-pre-line">{title}</h2>
          </button>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;
